<script setup lang="ts">
useHead({
  bodyAttrs: {
    id: "promo",
  }
});
</script>

<template>
  <div>
    <slot />
  </div>
</template>
